import React, {useContext, useEffect, useMemo, useState} from "react";
import objectPath from "object-path";
import { useLocation } from 'react-router-dom'
import {useHtmlClassService} from "../_core/MetronicLayout";
import {Header} from "./header/Header";
import {HeaderMobile} from "./header-mobile/HeaderMobile";
import {Aside} from "./aside/Aside";
import {Footer} from "./footer/Footer";
import {LayoutInit} from "./LayoutInit";
import {SubHeader} from "./subheader/SubHeader";
import { useSelector } from "react-redux";
import BackdropFilter from "./BackdropFilter";
import BackdropFilterOnce from "./BackdropFilterOnce";
import Axios from "axios";
import { EncryptStorage } from "encrypt-storage";
import ShowTour from "./ShowTour";
import { ShowTourContext } from "../../../hooks/ContextStore";

const exemptedPages = [
    '/attorney',
    '/subscription',
    '/client/active',
    '/client/archive',
    '/client/prospective',
    '/lawyer',
    '/case-transfer',
    '/user-profile/personal-information'
];

export function Layout({ children }) {
    const {subscription_details} = useSelector(state => state.subscriptionData?.subscriptionData?.original);
    const [disabledDescription, setDisabledDiscription] = useState("");
    const [planModules, setPlanModules] = useState([]);
    const uiService = useHtmlClassService();
    const [showTour, setShowTour] = useContext(ShowTourContext);
    const [disabled, setDisabled] = useState(false);
    const { user } = useSelector((state) => state.auth);
    const role = user && user.data ? user.data.roles[0].name : null;
    const [freemiumText, setFreemiumText] = useState("");
    const [welcomeText, setWelcomeText] = useState("");
    const [freemiumVideo, setFreemiumVideo] = useState("");
    const [instructionalVideo, setInstructionalVideo] = useState("");
    const [fetchingModuleInfo, setFetchingModuleInfo] = useState(false);
    const [currentPlanModuleSlug, setCurrentPlanModuleSlug] = useState("");
    
    const layoutProps = useMemo(() => {
        return {
            layoutConfig: uiService.config,
            selfLayout: objectPath.get(uiService.config, "self.layout"),
            asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
            subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
            desktopHeaderDisplay: objectPath.get(
                uiService.config,
                "header.self.fixed.desktop"
            ),
            contentCssClasses: uiService.getClasses("content", true),
            contentContainerClasses: uiService.getClasses("content_container", true),
            contentExtended: objectPath.get(uiService.config, "content.extended")
        };
    }, [uiService]);

    const location = useLocation();

    const handleFetchPlanModules = async () => {
        await Axios.get(`api/v2/app-modules/available_modules/${subscription_details.subscription_plan_id}`)
        .then(res => {
            setPlanModules(res.data || []);
        });
    }

    useEffect(() => {
        handleFetchPlanModules();
    }, []);

    useEffect(() => {
        // If on an exempted page, not disabled
        if (exemptedPages.includes(location.pathname)) {
            setDisabled(false);
            setDisabledDiscription("");
            return;
        }
        // If planModules not loaded yet, consider disabled
        if (planModules.length === 0) {
            setDisabled(true);
            setDisabledDiscription("");
            return;
        }
        // Find matching module
        const planModule = planModules.find(planModule => location.pathname.includes(planModule.slug));
        if (planModule) {
            setCurrentPlanModuleSlug(planModule.slug);
            setFetchingModuleInfo(true);
            if (!planModule.is_enabled) {
                setDisabled(true);
                // Fetch description
            } else {
                setDisabled(false);
                setDisabledDiscription("");
            }
            let api_url = "";
            if(role === 'client'){
                api_url = `https://soil-hope.pockethost.io/api/collections/client_videos/records?page=1&perPage=1&filter=module_slug%20%3D%20%22${planModule.slug}%22&skipTotal=1`;
            } else {
                api_url = `https://soil-hope.pockethost.io/api/collections/legal_videos/records?page=1&perPage=1&filter=module_slug%20%3D%20%22${planModule.slug}%22&skipTotal=1`;
            };
            
            Axios.get(api_url)
            .then(res => {
                if(res?.data?.items?.length > 0){
                    let item = res.data.items[0];
                    setFreemiumText(item.freemium_text || "");
                    setWelcomeText(item.welcome_text || "");
                    setFreemiumVideo(`https://soil-hope.pockethost.io/api/files/${item.collectionId}/${item.id}/${item.video}` || "");
                    setInstructionalVideo(`https://soil-hope.pockethost.io/api/files/${item.collectionId}/${item.id}/${item.instructional_video}` || "");
                };
            })
            .finally(() => {
                setFetchingModuleInfo(false);
            });
        } else {
            setDisabled(false);
            setDisabledDiscription("");
        }
    }, [location.pathname, planModules]);

    return layoutProps.selfLayout !== "blank" ? (
        <>
            {/*begin::Main*/}
            <HeaderMobile/>
            <div className="d-flex flex-column flex-root">
                {/*begin::Page*/}
                <div className="d-flex flex-row flex-column-fluid page">
                    {layoutProps.asideDisplay && (<Aside/>)}
                    {/*begin::Wrapper*/}
                    <div className="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
                        <Header/>
                        {/*begin::Content*/}
                        <div
                            id="kt_content"
                            className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
                        >
                            {layoutProps.subheaderDisplay && <SubHeader/>}
                            {/*begin::Entry*/}
                            {!layoutProps.contentExtended && (
                                <div className="d-flex flex-column-fluid">
                                    {/*begin::Container*/}
                                    {/* <div className={!isDocumentPage ? layoutProps.contentContainerClasses : 'container-fluid'}>
                                        {children}
                                    </div> */}
                                         <div className={
                                        location.pathname.includes('estate-division')
                                            ? 'container-fluid content-container-estate-division'
                                            : 'container-fluid content-container-pages22'
                                    }>
                                        {disabled && (
                                            <BackdropFilter description={disabled ? freemiumText : welcomeText} videoUrl={disabled ? freemiumVideo : instructionalVideo} fetchingModuleInfo={fetchingModuleInfo} />
                                        )}
                                        <BackdropFilterOnce 
                                            description={welcomeText} 
                                            videoUrl={instructionalVideo} 
                                            fetchingModuleInfo={fetchingModuleInfo} 
                                            disabled={disabled}
                                            planModuleSlug={currentPlanModuleSlug}
                                        />
                                        {showTour && <ShowTour description={welcomeText} videoUrl={instructionalVideo} fetchingModuleInfo={fetchingModuleInfo}/>}
                                        {children}
                                    </div>
                                    {/*end::Container*/}
                                </div>
                            )}

                            {layoutProps.contentExtended && {children}}
                            {/*end::Entry*/}
                        </div>
                        {/*end::Content*/}
                        <Footer/>
                    </div>
                    {/*end::Wrapper*/}
                </div>
                {/*end::Page*/}
            </div>
            {/* <QuickUser/>
            <QuickPanel/>
            <ScrollTop/> */}
            {/* <StickyToolbar/> */}
            {/*end::Main*/}
            <LayoutInit />
        </>
    ) : (
        // BLANK LAYOUT
        <div className="d-flex flex-column flex-root">{children}</div>
    );
}
